import { useEffect, useState } from "react";
import { fetchCatalog, fetchInsights } from "@/lib/api";
import { shortName } from "@/lib/pricing";

const pl = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const SECTION_LABEL = { lista: "Listă de preț", sugestie: "Sugestie preț vânzare", oferte: "Oferte active", profit: "Profitabilitate" };

const Bars = ({ rows, label, unit, testId }) => {
  const max = Math.max(1, ...rows.map((r) => r.value));
  if (!rows.length) return <p className="st-hint">Încă nu există date.</p>;
  return (
    <ul className="ins-bars" data-testid={testId}>
      {rows.map((r) => (
        <li key={r.id}>
          <div className="ins-bar-head"><span>{label(r.id)}</span><b>{pl(r.value, ...unit)}</b></div>
          <div className="ins-bar"><span style={{ width: `${(r.value / max) * 100}%` }} /></div>
          {r.sub && <small>{r.sub}</small>}
        </li>
      ))}
    </ul>
  );
};

const PACK_LABEL = { pk1: "Pachet Start", pk2: "Pachet Salon Pro", pk3: "Pachet Prestige" };

export default function InsightsPanel({ users = [] }) {
  const [data, setData] = useState(null);
  const [names, setNames] = useState({});
  const [agent, setAgent] = useState("");
  useEffect(() => {
    fetchCatalog().then((c) => setNames(Object.fromEntries(c.products.map((p) => [p.id, `${shortName(p.name)} ${p.size}`])))).catch(() => {});
  }, []);
  useEffect(() => {
    fetchInsights(agent).then(setData).catch(() => setData({ sections: [], products: [], opened: [], offers: [], ordered: [], orders: 0 }));
  }, [agent]);
  if (!data || !Object.keys(names).length) return null;
  const pname = (id) => names[id] || id;
  return (
    <section className="invite-box" data-testid="insights-panel">
      <div className="ins-head">
        <h3>Ce privesc clienții</h3>
        <select value={agent} onChange={(e) => setAgent(e.target.value)} data-testid="insights-agent-select">
          <option value="">Toți agenții</option>
          {users.map((u) => <option key={u.user_id} value={u.user_id}>{u.name || u.email}</option>)}
        </select>
      </div>
      <p className="st-hint">Ultimele 30 de zile, {agent ? "pe linkul agentului ales" : "pe toate linkurile agenților"}. Comenzi WhatsApp trimise de clienți: <b data-testid="insights-orders-total">{data.orders}</b></p>
      <div className="ins-grid">
        <div>
          <div className="st-section-title">Secțiuni deschise</div>
          <Bars testId="insights-sections" rows={data.sections.map((s) => ({ id: s.id, value: s.count, sub: pl(s.clients, "client", "clienți") }))} label={(id) => SECTION_LABEL[id] || id} unit={["deschidere", "deschideri"]} />
        </div>
        <div>
          <div className="st-section-title">Produse deschise (fișă produs)</div>
          <Bars testId="insights-opened" rows={(data.opened || []).map((s) => ({ id: s.id, value: s.count, sub: pl(s.clients, "client", "clienți") }))} label={pname} unit={["deschidere", "deschideri"]} />
        </div>
        <div>
          <div className="st-section-title">Produse alese în calculator</div>
          <Bars testId="insights-products" rows={data.products.map((s) => ({ id: s.id, value: s.clients }))} label={pname} unit={["client", "clienți"]} />
        </div>
        <div>
          <div className="st-section-title">Oferte rapide deschise</div>
          <Bars testId="insights-offers" rows={(data.offers || []).map((s) => ({ id: s.id, value: s.count, sub: pl(s.clients, "salon", "saloane") }))} label={(id) => PACK_LABEL[id] || id} unit={["deschidere", "deschideri"]} />
        </div>
        <div>
          <div className="st-section-title">Produse din comenzi WhatsApp</div>
          <Bars testId="insights-ordered" rows={data.ordered.map((s) => ({ id: s.id, value: s.qty, sub: s.orders === 1 ? "într-o comandă" : `în ${s.orders} comenzi` }))} label={pname} unit={["buc.", "buc."]} />
        </div>
      </div>
    </section>
  );
}
